import ActionCableVue from 'actioncable-vue'
import Vue from 'vue'

Vue.use(ActionCableVue, {
  debug: process.env.VUE_APP_ENVIRONMENT === 'development',
  debugLevel: 'error',
  connectionUrl: process.env.VUE_APP_SPINE_ACTIONCABLE_URL,
  connectImmediately: false
})
